import React, { useState, useEffect, useRef } from 'react';
import { getUserById, getUsers, clearUsers, editUserPrivileges } from '../../flux/actions/userActions';
import { getAllSocietes, clearSocietes } from '../../flux/actions/societeActions';
import { Container, Row, Col, Button, Input, Label, FormGroup } from 'reactstrap';

import { connect } from 'react-redux';
import { UserCardContainer, IUserCardReduxProps } from '../../types/interfaces';
import UserEdit from '../user/UserEdit';
import PrivilegeUsersModal from './PrivilegeUsersModal';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCity, faClipboard, faCommentAlt, faCrown, faExclamationCircle, faExternalLinkAlt, faGlasses, faHashtag, faPen, faPhone, faQuestionCircle, faSave, faSearch, faSignature, faSortAmountDown, faSortAmountUp, faSpinner, faUser } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { PRIVILEGE } from '../../types/privileges'
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const UserCardContainerComponent = ({ 
  getUserById,
  getUsers,
  clearUsers,
  getAllSocietes,
  clearSocietes,
  editUserPrivileges,
  user,
  societe,
  auth
 }: UserCardContainer) => {
  const history = useHistory();
  const alert = useAlert();
  const { info, users, loading } = user;
  const { societes, loading: loadingS } = societe;
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [commercialChecked, setCommercialChecked] = useState(false);
  const [comptableChecked, setComptableChecked] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);
  const commercialCheckedRef = useRef<HTMLInputElement>(document.createElement("input"));
  const comptableCheckedRef = useRef<HTMLInputElement>(document.createElement("input"));
  const adminCheckedRef = useRef<HTMLInputElement>(document.createElement("input"));
  const allPrivileges = [
    {code: "VENTE_NORMALE", label: "Vente normale", group: "COMMERCIAL"},
    {code: "VENTE_ASSOCIATION", label: "Vente association", group: "COMMERCIAL"},
    {code: "ADD_ENCAISSEMENT", label: "Ajout d'un nouvel encaissement", group: "COMMERCIAL"},
    {code: "CONSULTATION", label: "Consultation d'une vente", toolTip: "Que des projets qu'il en a accès", group: "COMMERCIAL"},
    {code: "LIST_VENTES", label: "Accès liste des ventes", toolTip: "Que les projets qu'il en a accès", group: "COMMERCIAL"},
    {code: "MY_VENTES", label: "Accès ses propres ventes", group: "COMMERCIAL"},
    {code: "ADD_CLIENT", label: "Ajout d'un nouveau client", group: "COMMERCIAL"},
    {code: "EDIT_CLIENTS", label: "Modification des clients", group: "COMMERCIAL"},
    {code: "LIST_CLIENTS", label: "Voir tous les clients", group: "COMMERCIAL"},
    {code: "ADD_VISITORS", label: "Ajout des visiteurs", group: "COMMERCIAL"},
    {code: "LIST_VISITORS", label: "Voir tous les visiteurs", group: "COMMERCIAL"},
    {code: "LIST_BIEN", label: "Accès liste des biens", group: "COMMERCIAL"},
    {code: "EDIT_CHARGE", label: "Modification du chargé du bien", group: "COMMERCIAL"},
    {code: "NOTAIRE_EN_COURS", label: "Mettre un bien signé client", group: "COMMERCIAL"},
    {code: "SIGNE_NOTAIRE", label: "Rendre un bien signé notaire", group: "COMMERCIAL"},
    {code: "SUMMARY_PROJECT", label: "Récap par projet", group: "COMMERCIAL"},
    {code: "ACCESS_ALL_USERS", label: "Accès aux ventes des autres commerciaux", toolTip: "Que les projets qu'il en a accès", group: "COMMERCIAL"},
    {code: "ACCESS_NOTAIRE", label: "Accès aux ventes signés notaire", group: "COMMERCIAL"},
    {code: "OWN_GOAL", label: "Accès son objectif", group: "COMMERCIAL"},
    {code: "COMMISSIONS_PAGE", label: "Accès ses commissions", group: "COMMERCIAL"},
    {code: "OTHERS_COMMISSIONS", label: "Accès aux commissions des autres commerciaux", toolTip: "Que les projets qu'il en a accès", group: "COMMERCIAL"},
    {code: "SEE_COMMISSIONS_FORMULAS", label: "Voir les méthodes de calcul commissions", group: "COMMERCIAL"},
    {code: "COMMISSIONS_BULLETIN", label: "Accès à son Bulletin de commission", group: "COMMERCIAL"},
    {code: "POURCENTAGES_PARTS", label: "Total des pourcentages des parts", group: "COMMERCIAL"},
    {code: "EDIT_ASSOCIATION", label: "Modification des parts Associations", group: "COMMERCIAL"},
    {code: "ADD_DIVISION", label: "Création des répartitions", group: "COMMERCIAL"},
    {code: "APPROVE_DIVISION", label: "Validation des répartitions", group: "COMMERCIAL"},
    {code: "EDIT_CONTRAT_MONTH", label: "Modification du délai prévisionnel d’achèvement des travaux", group: "COMMERCIAL"},
    {code: "PLAN_MASSE", label: "Accès plan de masse", toolTip: "Que des projets qu'il en a accès", group: "COMMERCIAL"},

    {code: "PORTEFEUILLE_BUREAU_VENTE", label: "Portefeuille bureau de vente", group: "COMPTABLE"},
    {code: "PORTEFEUILLE_SIEGE", label: "Portefeuille siège", group: "COMPTABLE"},
    {code: "RAPPROCHEMENT_ENC", label: "Rapprochement relevé de compte", group: "COMPTABLE"},
    {code: "ENCAISSE_IMPAYE", label: "Encaissé/Impayé", group: "COMPTABLE"},
    {code: "REPLACE_ENCAISSEMENT", label: "Remplacement des chèques", group: "COMPTABLE"},
    {code: "LIST_ENCAISSEMENTS", label: "Tous les encaissements", group: "COMPTABLE"},
    {code: "LIST_ENCAISSEMENTS_NOTAIRE", label: "Page \"encaissements notaire\"", group: "COMPTABLE"},
    {code: "SEND_ENC_TO_COMPTA", label: "Envoyer les encaissements à la comptabilité", group: "COMPTABLE"},
    {code: "EDIT_ENCAISSEMENT", label: "Modifier les encaissements", group: "COMPTABLE"},

    {code: "USERS", label: "Gestion des utilisateurs", group: "ADMIN"},
    {code: "BANQUES_VIREMENT", label: "Banques virements", group: "ADMIN"},
    {code: "FICHE_DESISTEMENT", label: "Fiches Désistements", group: "ADMIN"},
    {code: "DESISTEMENT", label: "Désistements", group: "ADMIN"},
    {code: "TRANSFERT", label: "Transferts", group: "ADMIN"},
    {code: "CHANGEMENT_BIEN", label: "Changement de bien", group: "ADMIN"},
    {code: "PARC_INFORMATIQUE", label: "Parc informatique", group: "ADMIN"},
    {code: "DEBLOCAGE_BLOCAGE", label: "Déblocage / Blocage", group: "ADMIN"},
    {code: "TEMP_BLOCK", label: "Blocage 5 jours - 2 fois", group: "ADMIN"},
    {code: "REMISE_ADMIN", label: "Demandes de remise", group: "ADMIN"},
    {code: "ASSOCIATION_ADMIN", label: "Débloquer en association", group: "ADMIN"},
    {code: "EDIT_COMMISSIONS_FORMULAS", label: "Modification des méthodes de calcul commissions", group: "ADMIN"},
    {code: "EDIT_COMMISSIONS", label: "Modification des commissions", group: "ADMIN"},
    {code: "VALIDATE_COMMISSIONS", label: "Validation des commissions", group: "ADMIN"},
    {code: "EDIT_GOALS", label: "Modification des objectifs", group: "ADMIN"},
    {code: "LIST_GOALS", label: "Liste des objectifs", group: "ADMIN"},
    {code: "LIST_BUDGETS", label: "Accès budget", group: "ADMIN"},
    {code: "EDIT_BUDGETS", label: "Modification du budget", group: "ADMIN"},
    {code: "CHANGEMENT_PRIX", label: "Changement des prix", group: "ADMIN"},
    {code: "SEE_PRIX_MIN", label: "Voir les prix min", group: "ADMIN"},
    {code: "EDIT_PRIX_MIN", label: "Modifier les prix min", group: "ADMIN"},
    {code: "ACCESS_HIDDEN_BIENS", label: "Accès au biens cachés", group: "ADMIN"},
    {code: "EXPEDITION_MINUTE", label: "Modification date envoi minute au notaire", group: "ADMIN"},
    {code: "ENREGISTREMENT_MINUTE", label: "Modification date enregistrement minute", group: "ADMIN"},
    {code: "VALIDATION_ENC", label: "Valider les encaissements", group: "ADMIN"},
    {code: "MANAGE_NOTIFICATIONS", label: "Gestion des notifications", group: "ADMIN"},
  ];
  const [privileges, setPrivileges] = useState(Object.fromEntries([...allPrivileges.map(e => [e.code, false])]))
  const [privilegesTouched, setPrivilegesTouched] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [modalP, setModalP] = useState(false);
  const [modalPData, setModalPData] = useState<any>();
  const specialities = {
    [constants.ROLE_ADMIN]: {
      color: "black",
      text: "Administrateur"
    },
    [constants.ROLE_COMMERCIAL]: {
      color: "darkgreen",
      text: "Commercial"
    },
    [constants.ROLE_COMPTABLE]: {
      color: "darkblue",
      text: "Comptable"
    },
    [constants.ROLE_RESPONSABLE]: {
      color: "saddlebrown",
      text: "Responsable"
    },
    [constants.ROLE_PROMOTEUR]: {
      color: "saddlebrown",
      text: "Promoteur"
    },
    [constants.ROLE_INTERMEDIAIRE]: {
      color: "saddlebrown",
      text: "Intermédiaire"
    },
    [constants.ROLE_DG]: {
      color: "dimgrey",
      text: "Directeur Général"
    },
    [constants.ROLE_DC]: {
      color: "saddlebrown",
      text: "Directeur Commercial"
    },
    [constants.ROLE_DAF]: {
      color: "rebeccapurple",
      text: "Directeur Administratif et Financier"
    },
  }

  let { id } = useParams();

  useEffect(() => {
    if(id !== undefined && id !== null && !isNaN(id) && id >= 0)
      getUserById(id);
  }, [id]);

  useEffect(() => getAllSocietes(), [getAllSocietes])
  useEffect(() => getUsers(), [getUsers])

  useEffect(() => () => {
    // clearUsers();
    clearSocietes();
  }, [])

  const handleToggleEdit = () => setEditModal(!editModal);

  useEffect(() => {
    setPrivileges(Object.fromEntries([...allPrivileges.map(e => [e.code, !!info?.privileges?.includes(PRIVILEGE[e.code])])]))
    setPrivilegesTouched(false);
  }, [info])

  const handleCopy = (e) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    setCopiedFlag(true);
    setTimeout(() => setCopiedFlag(false), 2000);
  };

  const privilegeChangeHandler = (e, privilege) => {
    const temp = {...privileges};
    temp[privilege] = e.target.checked;
    setPrivileges({...temp})
    setPrivilegesTouched(true);
  };

  useEffect(() => {
    if(commercialCheckedRef.current)
      commercialCheckedRef.current.indeterminate = false;
    let commercialEntries = Object.entries(privileges).filter(e => allPrivileges.filter(e => e.group === "COMMERCIAL").find(t => t.code === e[0])).map(e => !!e[1]);
    if(commercialEntries.filter(e => !!e).length === commercialEntries.length)
      setCommercialChecked(true)
    else if(commercialEntries.filter(e => !e).length === commercialEntries.length)
      setCommercialChecked(false)
    else {
      setCommercialChecked(false);
      if(commercialCheckedRef.current)
        commercialCheckedRef.current.indeterminate = true;
    }
    
    if(comptableCheckedRef.current)
      comptableCheckedRef.current.indeterminate = false;
    let comptableEntries = Object.entries(privileges).filter(e => allPrivileges.filter(e => e.group === "COMPTABLE").find(t => t.code === e[0])).map(e => !!e[1]);
    if(comptableEntries.filter(e => !!e).length === comptableEntries.length)
      setComptableChecked(true)
    else if(comptableEntries.filter(e => !e).length === comptableEntries.length)
      setComptableChecked(false)
    else {
      setComptableChecked(false);
      if(comptableCheckedRef.current)
        comptableCheckedRef.current.indeterminate = true;
    }
    
    if(adminCheckedRef.current)
      adminCheckedRef.current.indeterminate = false;
    let adminEntries = Object.entries(privileges).filter(e => allPrivileges.filter(e => e.group === "ADMIN").find(t => t.code === e[0])).map(e => !!e[1]);
    if(adminEntries.filter(e => !!e).length === adminEntries.length)
      setAdminChecked(true)
    else if(adminEntries.filter(e => !e).length === adminEntries.length)
      setAdminChecked(false)
    else {
      setAdminChecked(false);
      if(adminCheckedRef.current)
        adminCheckedRef.current.indeterminate = true;
    }
  }, [privileges])

  const typeCheckedChangeHandler = (e, type) => {
    const temp = {...privileges};
    const privilegesToSet = allPrivileges.filter(e => e.group === type);
    for(let p of privilegesToSet)
      temp[p.code] = e.target.checked;
    setPrivileges({...temp})
    setPrivilegesTouched(true);
  };

  const callback = (success) => {
    setPrivilegesTouched(false);
    setDisableSubmit(false);
    if(success)
      alert.success("Permissions modifiées avec succès");
    else
      alert.error("Une erreur s'est produite");
  }

  const savePrivileges = () => {
    editUserPrivileges(id, Object.entries(privileges).filter(e => !!e[1]).map(e => PRIVILEGE[e[0]]), auth?.user?.id, callback)
  }

  const PrivilegeTag = ({data, key}) => <Col xs="12" sm="4" key={key}>
    <FormGroup check>
      <Input type="checkbox" id={data.code} checked={privileges[data.code]} onChange={t => privilegeChangeHandler(t, data.code)} />
      <Label for={data.code} check>{data.label}</Label>
      {!!data.toolTip && <>
        &nbsp;
        <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for={`${data.code}_tooltip`} />
        <ReactTooltip effect="solid" id={`${data.code}_tooltip`} type={"dark"}>
          {data.toolTip}
        </ReactTooltip>
      </>}
      &nbsp;<FontAwesomeIcon icon={faSearch} style={{cursor: "pointer"}} onClick={() => {setModalPData({id: PRIVILEGE[data.code], label: data.label}); setModalP(true)}} />
    </FormGroup>
  </Col>

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" sm="8"><h2 className="title">Gestion Utilisateur</h2></Col>
          <Col xs="12" sm="4" className="modalAddBtnCol">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setEditModal(true)}
              ><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modifier</Button>
          </Col>
        </Row>
      </Container>
      {info ? (
      <Container className="CardInfo">
        {info.speciality !== null && info.speciality !== undefined ? <Row>
          <Col xs="12" className="userSpecialityTagCol">
            <span style={{backgroundColor: specialities[info.speciality].color}}>
              <FontAwesomeIcon icon={faCrown} />&nbsp;<strong>{specialities[info.speciality].text}</strong>
            </span>
          </Col>
        </Row> : null}
        <Row>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>ID Utilisateur : </strong>{info.id ? info.id : "-"}
          </Col>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faUser} />&nbsp;<strong>Nom de Compte : </strong>{info.username || "-"}
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            {/* <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>Nom : </strong>{info.username || "-"} */}
            <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>Nom : </strong>{info.surname || info.given_name ? `${info.surname ? info.surname.charAt(0).toUpperCase() + info.surname.slice(1).toLowerCase() : ""} ${info.given_name ? info.given_name.charAt(0).toUpperCase() + info.given_name.slice(1).toLowerCase() : ""}` : "-"}
          </Col>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faPhone} />&nbsp;<strong>Téléphone : </strong>{info.phone ? <span style={{whiteSpace: "nowrap"}}>
              {info.phone.length >= 4 && info.phone[0] !== "0" ? ("+" + info.phone) : info.phone}
              <a data-tip data-for="telI" href={`tel:${(info.phone.length >= 4 && info.phone[0] !== "0" ? ("+" + info.phone) : info.phone).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
              <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
              <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(info.phone)} />
              <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
                <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
              </ReactTooltip>
            </span> : "-"}
          </Col>
        </Row>
        {info.comment ? (
        <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faCommentAlt} />&nbsp;<strong>Commentaire : </strong>{info.comment}
          </Col>
        </Row>
        ) : null}
        {info.bloque === 1 ? (
        <Row>
          <Col xs="12" style={{color: "red"}}>
            <FontAwesomeIcon icon={faExclamationCircle} />&nbsp;<strong>Le compte de cet utilisateur est bloqué.</strong>
          </Col>
        </Row>
        ) : null}
        <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faCity} />&nbsp;<strong>Travaille à : </strong>{info.worksatProjects?.length ? info.worksatProjects.map(e => <div className="cardSticker societeSticker">{e.LIBELE}</div>) : <i>aucun</i>}
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faGlasses} />&nbsp;<strong>Accès à : </strong>{info.societes?.length ? info.societes.map(e => <div className="cardSticker societeSticker">{e.LIBELE}</div>) : <i>aucun</i>}
          </Col>
        </Row>
        {/* <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faSortAmountUp} />&nbsp;<strong>Ont l'accès à ses activités : </strong>{info.superiors?.length ? info.superiors.map(e => <div className="cardSticker superiorSticker">{e["LOGIN"]}</div>) : <i>personne</i>}
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faSortAmountDown} />&nbsp;<strong>A l'accès à leurs activités : </strong>{info.underlings?.length ? info.underlings.map(e => <div className="cardSticker underlingSticker">{e["LOGIN"]}</div>) : <i>personne</i>}
          </Col>
        </Row> */}
      </Container>
      ) : `ID ${id} non valide.`}

      {info ? (
      <Container className="CardInfo privilegeCardInfo">
        <Row className="cardTitlesRow">
          <Col xs="12" className="border-0" style={{marginBottom: "0.5rem"}}>
            <h3>Privilèges / Permissions</h3>
          </Col>
        </Row>
        <Row className="cardTitlesRow">
          <Col xs="12" className="border-0" style={{marginBottom: "0.5rem"}}>
            <FormGroup check>
              <Input type="checkbox" id="commercial" style={{marginTop: "0.7rem"}} innerRef={commercialCheckedRef} checked={commercialChecked} onChange={(e) => typeCheckedChangeHandler(e, "COMMERCIAL")} />
              <Label for="commercial" className="cardTitles" style={{fontSize: "x-large"}} check>Commerce</Label>
            </FormGroup>
          </Col>
        </Row>
        {/* <Row className="justify-content-around"> */}
        <Row className="justify-content-around">
          {allPrivileges.filter(e => e.group === "COMMERCIAL").map((e, key) => <PrivilegeTag data={e} key={key} />)}
        </Row>
        <Row className="cardTitlesRow">
          <Col xs="12" className="border-0" style={{marginBottom: "0.5rem"}}>
            <FormGroup check>
              <Input type="checkbox" id="comptable" style={{marginTop: "0.7rem"}} innerRef={comptableCheckedRef} checked={comptableChecked} onChange={(e) => typeCheckedChangeHandler(e, "COMPTABLE")} />
              <Label for="comptable" className="cardTitles" style={{fontSize: "x-large"}} check>Comptabilité</Label>
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-around">
          {allPrivileges.filter(e => e.group === "COMPTABLE").map((e, key) => <PrivilegeTag data={e} key={key} />)}
        </Row>
        <Row className="cardTitlesRow">
          <Col xs="12" className="border-0" style={{marginBottom: "0.5rem"}}>
            <FormGroup check>
              <Input type="checkbox" id="admin" style={{marginTop: "0.7rem"}} innerRef={adminCheckedRef} checked={adminChecked} onChange={(e) => typeCheckedChangeHandler(e, "ADMIN")} />
              <Label for="admin" className="cardTitles" style={{fontSize: "x-large"}} check>Modération</Label>
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-around">
          {allPrivileges.filter(e => e.group === "ADMIN").map((e, key) => <PrivilegeTag data={e} key={key} />)}
        </Row>
        <Row className="justify-content-center" style={{padding: 0}}>
          <Col xs="12" md="5" style={{marginBottom: 0}}>
            <FormGroup>
              <Button
                className="btnA linesConfirmationBtn"
                style={{width: "100%"}}
                onClick={() => savePrivileges()}
                disabled={!privilegesTouched || disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faSave} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Enregister les modifications</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>
      ) : null}

      <UserEdit modal={editModal} setModal={setEditModal} handleToggle={handleToggleEdit} modalUser={info} users={users} societes={societes} />
      <PrivilegeUsersModal modal={modalP} setModal={setModalP} modalData={modalPData} />
    </>
  );
};

const mapStateToProps = (state: IUserCardReduxProps) => ({
  user: state.user,
  societe: state.societe,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getUserById, getUsers, clearUsers, getAllSocietes, clearSocietes, editUserPrivileges })(UserCardContainerComponent);
